export default {
  header: 'Przypięte aplikacje',
  subheader: 'Przeciągnij aplikacje, które mają pojawiać się na pasku nawigacji, na listę przypiętych aplikacji i ułóż je w kolejności, w jakiej mają się tam pojawiać.',
  pinnedApps: 'Przypięte aplikacje',
  pinnedAppsEmpty: 'Przeciągnij tutaj aplikacje, aby je przypiąć.',
  availableApps: 'Dostępne aplikacje',
  availableAppsEmpty: 'Wszystkie dostępne aplikacje są przypięte. Przeciągnij tutaj aplikację, aby ją odpiąć.',
};
